import React from "react";
import "./ItemPrice.css";

const ItemPrice = ({
  data,
  xpressChef,
  onChange,
  onDiscard,
  onSubmit,
  onImageUpdate
}) => {
  const { chefPrice, chefDiscount, itemPrice } = data;

  const handleInputChange = (e, field) => {
    onChange({ ...data, [field]: e.target.value });
  };

  const handleDiscard = () => {
    onDiscard();
  };

  return (
    <div className="item-price-container">
      <h2 className="title">Price</h2>
      <hr className="separator" />
      <label className="label">Chef Price</label>
      <div className="input-container">
        <span className="icon-style">₹</span>
        <input
          type="number"
          className="input-style"
          value={chefPrice}
          onChange={(e) => handleInputChange(e, "chefPrice")}
          pattern="\d*"
        />
      </div>
      {xpressChef ?
      <>
      <label className="label">Item Price</label>
      <div className="input-container">
        <span className="icon-style">₹</span>
        <input
          type="number"
          className="input-style"
          value={itemPrice}
          onChange={(e) => handleInputChange(e, "itemPrice")}
          pattern="\d*"
        />
      </div>
      </>
      : 
      <>
      <label className="label">
        Add an offer for your customers to try this item
      </label>
      <div className="input-container">
        <span className="icon-style">₹</span>
        <input
          type="number"
          className="input-style"
          value={chefDiscount}
          onChange={(e) => {
            handleInputChange(e, "chefDiscount");}}
          pattern="\d*"
        />
      </div>
      </>
      }
        <div className="button-group">
          <button
            className={`discard-button`}
            onClick={handleDiscard}
          >
            Back
          </button>
          {onImageUpdate ? <button
            className={`next-button ${chefPrice ? 'active' : 'disabled'}`}
            onClick={onImageUpdate}
            disabled={!chefPrice}
          >
            Edit Image
          </button> : null}

          <button
            className={`next-button ${chefPrice ? 'active' : 'disabled'}`}
            onClick={onSubmit}
            disabled={!chefPrice}
          >
            Publish
          </button>
        </div>
    </div>
  );
};

export default ItemPrice;
